// AUTO-GENERATED by scripts/fetch-secrets.sh â€” do not edit manually
// Fetched from GCP Secret Manager at build time
export const firebaseConfig = {
  "apiKey": "AIzaSyB7-4-N5AOIQea84BA8Rzb5pvegdeApzvQ",
  "authDomain": "raisy-prod.firebaseapp.com",
  "projectId": "raisy-prod",
  "storageBucket": "raisy-prod.firebasestorage.app",
  "messagingSenderId": "733538810609",
  "appId": "1:733538810609:web:5e8d8d96913ac6fb980750"
} as const;
